import ApiService from "../../services/api";
import moment from "moment";
import tripsMap from "./map.vue";
import horizontalTable from "./horizontalTable.vue";
import { bus } from "../../main";
import { mapGetters } from "vuex";
import helpers from "../../shared/fleetbox-helpers";

export default {
	components: {
		tripsMap,
		horizontalTable
	},

	data: function() {
		return {
			vehicleIdFilterField: "number_plate",
			vehicleIdFilterFieldFormatted: "",

			loading: false,
			positionNamePendingRequests: [],

			//filters
			showTableMapPopover: false,
			mapTableVisualizationSelected: "../../assets/m_ht.png",

			filtersByQuery: false,
			showMap: true,
			showTable: true,

			categories: [],

			vehicles: [],
			vehiclesSelected: [],

			codeFilters: [],
			codeFilterSelected: [],

			drivers: [],
			driversSelected: [],

			startDate: null,
			endDate: null,
			startTime: null,
			endTime: null,
			disableDates: function(date) {
				var now = moment();
				function compareDates(currentDate) {
					return moment(currentDate, moment.RFC_2822).isAfter(now, "days");
				}
				if (date && compareDates(date)) {
					return true;
				} else {
					return false;
				}
			},

			isVehicleFilterSelected: true,
			isDriverFilterSelected: false,

			datePickerFooter: "Oggi - #=kendo.toString(data, 'dd MMMM yyyy') #",

			itemVehicleTemplate: "<div style='height: 30px'>#= number_plate # <br /><div style='font-size: 8px'> #= name # </div></div>",
			tagVehicleTemplate: "<div style='height: 30px; text-align: left; padding-top: 3px;'>#= number_plate # <br /><div style='font-size: 8px'> #= name # </div></div>",

			itemDriverTemplate: "<div style='height: 30px'>#= surname # #= name #<br /><div style='font-size: 8px'> #= fiscal_code # </div></div>",
			tagDriverTemplate: "<div style='height: 30px; text-align: left; padding-top: 3px;'>#= surname # #= name #<br /><div style='font-size: 8px'> #= fiscal_code # </div></div>",

			//trips
			tripsSummaryItems: [],

			//map
			config: {
				mapInitialLocation: {
					lat: 43.1107,
					lng: 12.3908
				}
			},

			//table
			configTableColumns: [],
			tableParams: {
				pageSize: 10
			},
			totalCount: 0,
			canExportGridData: false,
			noPathTripKmMessage: "(*)",

			//update active item
			updateLoopInterval: 60,
			updateLoopItems: [],
			updateLoopIntervalObject: null,

			loadingGetData: false,
			loadingRealTimeData: false,
			loadingAddress: [],

			debug: false
		};
	},

	created() {
		var self = this;
		if (this.$route.query.debug) {
			this.debug = this.$route.query.debug == "true";
		}

		if (this.settings && this.settings.trips.refreshInterval) {
			this.updateLoopInterval = this.settings.trips.refreshInterval;
		}

		if (this.settings && this.settings.trips) {
			if (this.settings.trips.viewType == "map, horizontalGrid") {
				this.showMap = true;
				this.showTable = true;
			} else if (this.settings.trips.viewType == "horizontalGrid") {
				this.showMap = false;
				this.showTable = true;
			} else {
				this.showMap = true;
				this.showTable = false;
			}
		}

		if (this.settings && this.settings.commonLabels && this.settings.commonLabels.key_invalid_path_trip) {
			this.noPathTripKmMessage += ` - ${this.settings.commonLabels.key_invalid_path_trip}`;
		}

		this.vehicleIdFilterField = this.settings.vehicleIdFilterField;
		this.vehicleIdFilterFieldFormatted = "number_plate";
		if (this.vehicleIdFilterField == "code") {
			this.vehicleIdFilterFieldFormatted = "vehicle_code";
		}

		var icon = helpers.getIconForVisualizationType(this.showMap, this.showTable, false);
		this.mapTableVisualizationSelected = `../../${icon}`;

		if (this.settings && this.settings.canExportGridData) {
			this.canExportGridData = true;
		}

		this.defaultFilterDateRange();
		this.getAllVehicles();
		this.getAllDrivers();
		this.getCategoriesData();

		//get table trips config
		this.getConfig();

		if (this.$route.query && this.$route.query.vehicleId) {
			this.filtersByQuery = true;
		}

		bus.$on("filter-by-query", this.resetFilterByQuery.bind(this));
		bus.$on("on-trips-show-path", this.showPath.bind(this));
		bus.$on("on-trips-remove-path", this.hidePath.bind(this));
		bus.$emit("show-spinner-loading");

		bus.$on("set-address-to", self.onSetAddressRequest.bind(self));
	},

	mounted() {
		this.pollData();
	},

	beforeDestroy() {
		bus.$off("on-trips-show-path");
		bus.$off("on-trips-remove-path");
		bus.$off("set-address-to");
		
		clearInterval(this.updateLoopIntervalObject);
		this.updateLoopIntervalObject = null;
	},

	watch: {
		showTableMapPopover() {
			var self = this;
			self.$root.$emit("bv::hide::tooltip");
			setTimeout(() => {
				self.$root.$emit("bv::hide::tooltip");
			}, 700);
		},
		isLoadingData(loading) {
			if (loading) {
				bus.$emit("show-spinner-loading");
			} else {
				bus.$emit("hide-spinner-loading");
			}
		}
	},

	methods: {
		//#region filters
		applyFilter() {
			this.getData();
		},
		resetFilter() {
			this.vehiclesSelected = [];
			this.driversSelected = [];
			this.defaultFilterDateRange();
			this.getData();
		},
		showMaptable(v) {
			if (v == "ht") {
				this.showTable = !this.showTable;
			} else if (v == "m") {
				this.showMap = !this.showMap;
			}

			if (!this.showTable && !this.showMap) this.showMap = this.showTable = true;

			var icon = helpers.getIconForVisualizationType(this.showMap, this.showTable, false);
			this.mapTableVisualizationSelected = `../../${icon}`;

			this.onCloseShowTableMapPopover();
		},
		onCloseShowTableMapPopover() {
			this.showTableMapPopover = false;
		},
		resetFilterByQuery(value) {
			this.filtersByQuery = value;
			bus.$off("filter-by-query", this.resetFilterByQuery.bind(this));
		},
		onFilterDaterangeChange(e) {
			if (e.reset) {
				this.startTime = null;
				this.endTime = null;
				this.defaultFilterDateRange();
			} else if (e.type == "date") {
				this.startDate = e.startDate;
				this.endDate = e.endDate;
			} else if (e.type == "time") {
				this.startTime = e.startTime;
				this.endTime = e.endTime;
			}
		},
		onVehicleDriverFilterSelected(e) {
			if (e.indices[0] === 0) {
				//vehicle select
				this.isDriverFilterSelected = false;
				this.isVehicleFilterSelected = true;
				this.driversSelected = [];
			} else {
				//driver select
				this.isVehicleFilterSelected = false;
				this.isDriverFilterSelected = true;
				this.vehiclesSelected = [];
			}
		},
		defaultFilterDateRange() {
			var startDate = moment().startOf("day");
			this.startDate = startDate; //max from api
			var endDate = moment().endOf("days");
			this.endDate = endDate;
		},
		startDateChange(item) {
			var newStartDate = moment(item.sender.value());
			if (newStartDate > moment(this.endDate)) {
				var m = moment(item.sender.value()).endOf("days");
				this.endDate = m;
				this.endTime = m;
			}
			this.startTime = newStartDate;
			this.startDate = newStartDate;
			//this.getData();
		},

		endDateChange(item) {
			var newEndDate = moment(item.sender.value());
			if (newEndDate < moment(this.startDate)) {
				var m = moment(item.sender.value()).startOf("days");
				this.startDate = m;
				this.startTime = m;
			}
			this.endDate = newEndDate;
			this.endTime = newEndDate;
			//this.getData();
		},

		filterPlateChange(e) {
			this.vehiclesSelected = e.sender.value();
			//this.getData();
		},
		filterDriverChange(e) {
			this.driversSelected = e.sender.value();
			//this.getData();
		},

		getAllVehicles: function() {
			var self = this;
			ApiService.getVehiclesLookup({ page: 0, pageSize: 1000000 }, this.vehicleIdFilterField).then(res => {
				self.vehicles = res.items.map(function(vehicle) {
					return {
						id: vehicle.id,
						name: vehicle.name,
						number_plate: vehicle.number_plate,
						name_numberplate: `${vehicle.number_plate} ${vehicle.name}`,
						code: vehicle.code ? vehicle.code : ""
					};
				});

				for (var i = 0; i < self.vehicles.length; i++) {
					var vehicle = self.vehicles[i];
					if (vehicle.code) {
						var alreadyExist =
							self.codeFilters.findIndex(item => {
								return item.id == vehicle.code;
							}) >= 0;
						if (!alreadyExist) {
							self.codeFilters.push({
								id: vehicle.code,
								value: vehicle.code
							});
						}
					}
				}
			});
		},
		getAllDrivers() {
			var self = this;
			ApiService.getDriversData({ page: 0, pageSize: 100000, onlyActiveWithBox: true }).then(res => {
				self.drivers = res.items.map(function(driver) {
					return {
						id: driver.id,
						name: driver.name ? driver.name.toLowerCase() : "",
						surname: driver.surname ? driver.surname.toLowerCase() : "",
						name_surname_fiscalcode: `${driver.name} ${driver.surname} ${driver.fiscal_code}`,
						fiscal_code: driver.fiscal_code
					};
				});

				self.drivers = self._.sortBy(self.drivers, ["surname, name"]);

				self.drivers.unshift({
					id: 0,
					name: "NON DISPONIBILE",
					surname: "",
					fiscal_code: ""
				});
			});
		},
		//#endregion

		//#region table
		saveColumnsConfiguration() {
			var configData = {
				section: "fleerun_trips",
				data: []
			};

			this.configTableColumns.forEach(col => {
				if (!col.configByPass) {
					configData.data.push({
						field: col.field,
						enabled: col.enabled
					});
				}
			});

			ApiService.setUserVisibleColumns(configData);
		},
		getConfig: function() {
			var self = this;
			ApiService.getViewConfig("fleerun_trips").then(res => {
				self.configTableColumns = res;
			});
		},
		onSortOrPageChangeHandler(query) {
			this.tableParams = query;
			this.getData();
		},
		onSelectedRow(e) {},
		downloadXlsx(type) {
			var self = this;
			var query = this.getQueryParams();
			if (type == "csv") query["format"] = "csv";
			ApiService.exportXlsx("trips", query).then(res => {
				let blob = self.$options.filters.b64toBlob(res.data.fileContents);
				let link = document.createElement("a");
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", res.data.fileDownloadName || `Viaggi.${type}`);
				link.style = "visibility:hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			});
		},
		//#endregion

		//#region map
		onMarkerClick(e) {},
		//#endregion

		//#region Trips
		showPath(e) {
			if (e) {
				if (e.status == "active") {
					var itemIndex = this.updateLoopItems.findIndex(function(item) {
						return item == e.id;
					});

					if (itemIndex < 0) this.updateLoopItems.push(e);
				}
			}
		},

		hidePath(e) {
			if (e) {
				this.removePathFromUpdateLoop(e.id);
			}
		},

		removePathFromUpdateLoop(itemId) {
			var itemToRemoveIndex = this.updateLoopItems.findIndex(function(item) {
				return item.id == itemId;
			});

			if (itemToRemoveIndex >= 0) {
				this.updateLoopItems.splice(itemToRemoveIndex, 1);
			}
		},

		pollData() {
			var self = this;
			this.updateLoopIntervalObject = setInterval(() => {
				if (self.updateLoopItems.length > 0) {
					var dataRequest = [];
					for (var i = 0; i < self.updateLoopItems.length; i++) {
						let trip = self.updateLoopItems[i];
						dataRequest.push({
							id: trip.id,
							includeAlarms: trip.alarms,
							includeDiagnosis: trip.diagnostic
						});
					}

					ApiService.getTripDataByIdsWithAlarmAndDiagnosis(dataRequest).then(res => {
						if (res && res.length > 0) {
							for (var j = 0; j < res.length; j++) {
								let tripData = res[j];
								let a = tripData.trip;
								if (a) {
									if (a.status == "off") {
										self.removePathFromUpdateLoop(a.id);
									}

									//map response like --> cellDetailTemplate <--
									let dataItemTrip = {
										id: a.id,
										pois: a.associated_pois,
										create_date: a.create_date,
										update_date: a.update_date,
										avg_co2_emission: a.tags.some(tag => tag == "valid_trip_consumption") ? a.avg_co2_emission : "(*)",
										avg_fuel_consumption: a.tags.some(tag => {
											return tag == "valid_trip_consumption";
										})
											? a.interpolated_consumption_lt_hkm
											: "(*)",
										avg_brand_fuel_consumption: a.brand_fuel_consumption,
										avg_training_fuel_consumption: "(*)",
										brand_total_lt: a.brand_total_lt,
										fuel_consumption_km_lt: a.tags.some(tag => {
											return tag == "valid_trip_consumption";
										})
											? a.interpolated_consumption_km_lt
											: "(*)",
										avg_speed: a.tags.some(tag => {
											return tag == "no_positions";
										})
											? "(*)"
											: a.avg_speed,
										co2_emitted: a.tags.some(tag => tag == "valid_trip_consumption") || !a.tags.some(tag => tag == "no_valid_lt") ? a.co2_emitted : "(*)",
										drive_time: self.$options.filters.timeFromSecondsToString(a.drive_time),
										driver_id: a.driver_id,
										driver_name: a.driver_name,
										mobile_phone_number: a.mobile_phone_number,
										first_start_location: a.start_location,
										first_start_location_display_name: a.start_location_display_name,
										idle_time: self.$options.filters.timeFromSecondsToString(a.idle_time),
										last_end_location: a.end_location,
										last_end_location_display_name: a.end_location_display_name,
										last_known_location: a.last_known_location,
										last_known_location_display_name: a.last_known_location_display_name,
										path: a.path,
										max_speed: a.tags.some(tag => {
											return tag == "no_positions";
										})
											? "(*)"
											: a.max_speed,
										number_of_trips: a.number_of_trips,
										number_plate: a.number_plate || self.number_plate,
										speedometer_trip_km: self.$options.filters.mToKm(a.speedometer_trip_km),
										gps_trip_km: a.gps_trip_km,
										path_trip_km: a.tags.some(tag => {
											return tag == "no_valid_path_km";
										})
											? "(*)"
											: a.path_trip_km,
										interpolated_trip_km: a.tags.some(tag => {
											return tag == "no_valid_interpolated_km";
										})
											? "(*)"
											: a.interpolated_trip_km,
										interpolated_trip_lt: a.tags.some(tag => tag == "valid_trip_consumption") || !a.tags.some(tag => tag == "no_valid_lt") ? a.interpolated_trip_lt : "(*)",
										path_trip_km_value: a.path_trip_km,
										interpolated_trip_km_value: a.interpolated_trip_km,
										interpolated_trip_lt_value: a.interpolated_trip_lt,
										trip_time: self.$options.filters.timeFromSecondsToString(a.trip_time),
										vehicle_id: a.vehicle_id,
										vehicle_code: a.vehicle_code,
										vehicle_name: a.vehicle_name,
										privacy_mode: a.privacy_mode,
										check: a.check,
										status: a.status,

										//custom field
										first_trip_start_date: self.$options.filters.dateToString(a.trip_start_date),
										first_trip_start_time: self.$options.filters.timeToString(a.trip_start_date),
										last_trip_end_date: self.$options.filters.dateToString(a.trip_end_date),
										last_trip_end_time: self.$options.filters.timeToString(a.trip_end_date)
									};

									var itemToUpdate = self.tripsSummaryItems.find(function(ts) {
										return (
											ts.detailRow &&
											ts.detailRow.findIndex(function(dRow) {
												return dRow.id == dataItemTrip.id;
											}) >= 0
										);
									});

									if (itemToUpdate) {
										var dTs = itemToUpdate.detailRow.find(function(dRow) {
											return dRow.id == dataItemTrip.id;
										});

										if (dTs) {
											dTs.pois = dataItemTrip.pois;
											dTs.create_date = dataItemTrip.create_date;
											dTs.update_date = dataItemTrip.update_date;
											dTs.avg_co2_emission = dataItemTrip.avg_co2_emission;
											dTs.avg_fuel_consumption = dataItemTrip.avg_fuel_consumption;
											dTs.avg_brand_fuel_consumption = dataItemTrip.avg_brand_fuel_consumption;
											dTs.avg_training_fuel_consumption = dataItemTrip.avg_training_fuel_consumption;
											dTs.brand_total_lt = dataItemTrip.brand_total_lt;
											dTs.fuel_consumption_km_lt = dataItemTrip.fuel_consumption_km_lt;
											dTs.avg_speed = dataItemTrip.avg_speed;
											dTs.co2_emitted = dataItemTrip.co2_emitted;
											dTs.drive_time = dataItemTrip.drive_time;
											dTs.driver_id = dataItemTrip.driver_id;
											dTs.driver_name = dataItemTrip.driver_name;
											dTs.mobile_phone_number = dataItemTrip.mobile_phone_number;
											dTs.first_start_location = dataItemTrip.first_start_location;
											dTs.first_start_location_display_name = dataItemTrip.first_start_location_display_name;
											dTs.idle_time = dataItemTrip.idle_time;
											dTs.last_end_location = dataItemTrip.last_end_location;
											dTs.last_end_location_display_name = dataItemTrip.last_end_location_display_name;
											dTs.last_known_location = dataItemTrip.last_known_location;
											dTs.last_known_location_display_name = dataItemTrip.last_known_location_display_name;
											dTs.path = dataItemTrip.path;
											dTs.max_speed = dataItemTrip.max_speed;
											dTs.number_of_trips = dataItemTrip.number_of_trips;
											dTs.number_plate = dataItemTrip.number_plate;
											dTs.speedometer_trip_km = dataItemTrip.speedometer_trip_km;
											dTs.gps_trip_km = dataItemTrip.gps_trip_km;
											dTs.path_trip_km = dataItemTrip.path_trip_km;
											dTs.interpolated_trip_km = dataItemTrip.interpolated_trip_km;
											dTs.interpolated_trip_lt = dataItemTrip.interpolated_trip_lt;
											dTs.path_trip_km_value = dataItemTrip.path_trip_km_value;
											dTs.interpolated_trip_km_value = dataItemTrip.interpolated_trip_km_value;
											dTs.interpolated_trip_lt_value = dataItemTrip.interpolated_trip_lt_value;
											dTs.trip_time = dataItemTrip.trip_time;
											dTs.vehicle_id = dataItemTrip.vehicle_id;
											dTs.vehicle_code = dataItemTrip.vehicle_code;
											dTs.vehicle_name = dataItemTrip.vehicle_name;
											dTs.privacy_mode = dataItemTrip.privacy_mode;
											dTs.check = dataItemTrip.check;
											dTs.status = dataItemTrip.status;
											dTs.first_trip_start_date = dataItemTrip.first_trip_start_date;
											dTs.first_trip_start_time = dataItemTrip.first_trip_start_time;
											dTs.last_trip_end_date = dataItemTrip.last_trip_end_date;
											dTs.last_trip_end_time = dataItemTrip.last_trip_end_time;
										}
									}

									bus.$emit("on-trips-update-path", dataItemTrip);
								}

								let alarms = tripData.tripAlarms;
								if (alarms && alarms.length > 0) {
									bus.$emit("on-trips-remove-alarms", dTs);
									self.$nextTick(function() {
										bus.$emit("on-trips-show-alarms", { dataItem: dTs, alarmsData: alarms });
									});
								}

								let diagnostics = tripData.tripDiagnosis;
								if (diagnostics && diagnostics.length > 0) {
									bus.$emit("on-trips-remove-diagnostic", dTs);
									self.$nextTick(function() {
										bus.$emit("on-trips-show-diagnostic", { dataItem: dTs, diagnosticData: alarms });
									});
								}
							}
						}
					});
				}
			}, self.updateLoopInterval * 1000);
		},

		setDateTimeFilter() {
			var startTime = null;
			if (this.startTime) {
				startTime = moment(this.startTime);
			}
			var endTime = null;
			if (this.endTime) {
				endTime = moment(this.endTime);
			}

			if (this.startDate) {
				if (startTime) {
					this.startDate.set({
						hour: startTime.get("hour"),
						minute: startTime.get("minute"),
						second: startTime.get("second")
					});
				} else {
					this.startDate = this.startDate.startOf("days");
				}
			}

			if (this.endDate) {
				if (endTime) {
					this.endDate.set({
						hour: endTime.get("hour"),
						minute: endTime.get("minute"),
						second: endTime.get("second")
					});
				} else {
					this.endDate = this.endDate.endOf("days");
				}
			}
		},
		getQueryParams() {
			var self = this;
			var query = {};

			let filterPlatesSelected = [];
			for (var i = 0; i < this.vehiclesSelected.length; i++) {
				let vehicleId = this.vehiclesSelected[i];
				let vehicle = this.vehicles.find(function(x) {
					return x.id == vehicleId;
				});

				if (self.vehicleIdFilterField == "code") {
					if (vehicle) filterPlatesSelected.push(vehicle.id);
				} else {
					if (vehicle) filterPlatesSelected.push(vehicle.number_plate);
				}
			}

			if (self.filtersByQuery && self.$route.query && self.$route.query.vehicleId) {
				var numberPlateFiltered = self.$route.query.vehicleId;
				setTimeout(() => {
					var vehicleSelected = self.vehicles.find(item => {
						return item[self.vehicleIdFilterField].toLowerCase() == numberPlateFiltered.toLowerCase();
					});
					if (vehicleSelected) self.vehiclesSelected.push(vehicleSelected.id);
				}, 200);
				if (self.vehicleIdFilterField == "code") {
					var vehicle = self.vehicles.find(item => {
						return item.code.toLowerCase() == numberPlateFiltered.toLowerCase();
					});
					if (vehicle) filterPlatesSelected.push(vehicle.id);
				} else {
					filterPlatesSelected.push(numberPlateFiltered);
				}

				if (self.$route.query.startDay) {
					self.startDate = moment(self.$route.query.startDay).startOf("day");
					self.endDate = moment(self.$route.query.startDay).endOf("day");
				}
			}

			if (self.vehicleIdFilterField == "code") {
				if (filterPlatesSelected.length > 0) query.vehicleCodes = filterPlatesSelected;
			} else {
				if (filterPlatesSelected.length > 0) query.plates = filterPlatesSelected;
			}

			let driverPlatesSelected = [];
			for (var i = 0; i < this.driversSelected.length; i++) {
				let driverId = this.driversSelected[i];
				let driver = this.drivers.find(function(x) {
					return x.id == driverId;
				});

				if (driver) driverPlatesSelected.push(driver.id);
			}

			if (driverPlatesSelected.length > 0) query.drivers = driverPlatesSelected;

			this.setDateTimeFilter();
			if (this.startDate) {
				query["startRange.from"] = moment(this.startDate)
					.utc()
					.format();
			}

			if (this.endDate) {
				query["startRange.to"] = moment(this.endDate)
					.utc()
					.format();
			}

			query.sort = this.tableParams.sort;

			return query;
		},
		getData() {
			var self = this;

			var query = this.getQueryParams();

			//bus.$emit("show-spinner-loading");
			this.loadingGetData = true;
			this.loadingAddress = [];

			ApiService.getTripsSummaryData(query)
				.then(res => {
					if (res) {
						//var oldTripItems = self._.clone(self.tripsSummaryItems);
						self.totalCount = res.length;

						self.tripsSummaryItems = res.map(a => {
							return {
								avg_co2_emission: a.tags.some(tag => tag == "valid_trip_consumption") || !a.tags.some(tag => tag == "no_valid_lt") ? a.avg_co2_emission : "(*)",
								avg_fuel_consumption: a.tags.some(tag => tag == "valid_trip_consumption") || !a.tags.some(tag => tag == "no_valid_lt") ? a.avg_fuel_consumption : "(*)",
								avg_brand_fuel_consumption: a.brand_fuel_consumption,
								fuel_consumption_km_lt: a.tags.some(tag => tag == "valid_trip_consumption") || !a.tags.some(tag => tag == "no_valid_lt") ? a.fuel_consumption_km_lt : "(*)",
								avg_training_fuel_consumption: a.avg_training_fuel_consumption,
								brand_total_lt: a.brand_total_lt,
								avg_speed: a.tags.some(tag => tag == "no_positions") ? "(*)" : a.avg_speed,
								co2_emitted: a.tags.some(tag => tag == "valid_trip_consumption") || !a.tags.some(tag => tag == "no_valid_lt") ? a.co2_emitted : "(*)",
								drive_time: self.$options.filters.timeFromSecondsToString(a.drive_time),
								driver_id: a.driver_id,
								driver_name: a.driver_name,
								first_start_location: a.first_start_location,
								first_start_location_display_name: a.first_start_location_display_name,
								//first_trip_start_date: a.first_trip_start_date,
								idle_time: self.$options.filters.timeFromSecondsToString(a.idle_time),
								last_end_location: a.last_end_location,
								last_end_location_display_name: a.last_end_location_display_name,
								last_known_location: a.last_known_location,
								last_known_location_display_name: a.last_known_location_display_name,
								//last_trip_end_date: a.last_trip_end_date,
								max_speed: a.tags.some(tag => tag == "no_positions") ? "(*)" : a.max_speed,
								number_of_trips: a.number_of_trips,
								number_plate: a.number_plate,
								vehicle_code: a.vehicle_code,
								//speedometer_final_value: self.$options.filters.mToKm(a.speedometer_final_value),
								//speedometer_initial_value: self.$options.filters.mToKm(a.speedometer_initial_value),
								speedometer_trip_km: self.$options.filters.mToKm(a.speedometer_trip_km),
								gps_trip_km: a.gps_trip_km,
								path_trip_km: a.tags.some(tag => tag == "no_valid_path_km") ? "(*)" : a.path_trip_km,
								interpolated_trip_km: a.tags.some(tag => tag == "no_valid_interpolated_km") ? "(*)" : a.interpolated_trip_km,
								interpolated_trip_lt: a.tags.some(tag => tag == "valid_trip_consumption") || !a.tags.some(tag => tag == "no_valid_lt") ? a.interpolated_trip_lt : "(*)",
								trip_time: self.$options.filters.timeFromSecondsToString(a.trip_time),
								vehicle_id: a.vehicle_id,
								vehicle_name: a.vehicle_name,
								first_start_location_trip_id: a.first_start_location_trip_id,
								last_end_location_trip_id: a.last_end_location_trip_id,
								first_last_privacy_mode: a.first_last_privacy_mode,
								last_last_privacy_mode: a.last_last_privacy_mode,

								//custom field
								first_trip_start_date: self.$options.filters.dateToString(a.first_trip_start_date),
								first_trip_start_time: self.$options.filters.timeToString(a.first_trip_start_date),
								last_trip_end_date: self.$options.filters.dateToString(a.last_trip_end_date),
								last_trip_end_time: self.$options.filters.timeToString(a.last_trip_end_date),

								//status
								status_icon: "/assets/map/icon/blank.png",
								statusFriendly: "sconosciuto",

								visible: false,
								visibility: false,
								expanded: false,

								debugData: self.debug ? JSON.stringify(a, undefined, 2) : null
							};
						});

						//self.totalCount = res.length;

						// if (oldTripItems && oldTripItems.length > 0 && self.tripsSummaryItems) {
						// 	//remove markers if needed
						// 	var pathsToRemoveByNumberPlate = [];
						// 	for (var i = 0; i < oldTripItems.length; i++) {
						// 		let oti = oldTripItems[i];
						// 		var tripSummary = self.tripsSummaryItems.find(m => {
						// 			return m.number_plate == oti.number_plate;
						// 		});

						// 		if (tripSummary) {
						// 			tripSummary.visible = oti.visible;
						// 			if (oti.detailRow) {
						// 				tripSummary.detailRow = oti.detailRow;
						// 			}
						// 		} else {
						// 			var existsPathsToRemove = oti.detailRow.find(function(item) {
						// 				return item.visible === true;
						// 			});
						// 			if (existsPathsToRemove) {
						// 				pathsToRemoveByNumberPlate.push(oti.number_plate);
						// 			}
						// 		}
						// 	}

						// 	if (pathsToRemoveByNumberPlate.length > 0) {
						// 		for (var i = 0; i < self.pathsToRemoveByNumberPlate.length; i++) {
						bus.$emit("on-trips-filters-change");
						// 		}
						// 	}
						// }

						if (self.filtersByQuery && self.$route.query && self.$route.query.vehicleId) {
							var numberPlate = self.$route.query.vehicleId;

							var vehicle = self.tripsSummaryItems.find(item => {
								return item[self.vehicleIdFilterFieldFormatted].toLowerCase() == numberPlate.toLowerCase();
							});

							if (vehicle) vehicle.expanded = true;
							if (!self.$route.query.pathId) self.filtersByQuery = false;
						}

						self.loadingRealTimeData = true;
						ApiService.getRealtimeStatusGeolocation(this.query)
							.then(resRT => {
								if (resRT && resRT.length > 0) {
									for (var x = 0; x < resRT.length; x++) {
										var numberPlate = resRT[x].number_plate;
										var vehicle = self.tripsSummaryItems.find(item => {
											return item.number_plate == numberPlate;
										});
										if (vehicle) {
											vehicle.status_icon = self.getIconFromCategories(resRT[x].category_id, resRT[x].status, resRT[x].last_privacy_mode, resRT[x].box_active);
											vehicle.statusFriendly = self.getUserFriendlyStatus(resRT[x].status, resRT[x].last_privacy_mode);
										}
									}
								}
							})
							.finally(() => {
								//bus.$emit("hide-spinner-loading");
								self.loadingRealTimeData = false;
							});

						//self.setAddress();
					}
				})
				.finally(() => {
					//bus.$emit("hide-spinner-loading");
					self.loadingGetData = false;
				});
		},
		onSetAddressRequest(items) {
			this.setAddress(items);
		},
		getUserFriendlyStatus(status, lastPrivacyMode) {
			if (lastPrivacyMode) {
				return "privato";
			}

			switch (status) {
				case "off":
					return "fermo";
					break;
				case "stop":
					return "inattivo";
					break;
				case "active":
					return "movimento";
					break;
				default:
					return "sconociuto";
					break;
			}
		},
		setAddress(items) {
			var self = this;

			var updateServerAddressBulk = function(data) {
				ApiService.setTripPositionDisplayNameBulk(data);
			};

			var bulkGetAddress = function(data, position) {
				if (data.length > 0) {
					//self.loadingAddress.push(true);

					ApiService.getBulkReverseGeocoding(data)
						.then(resBulk => {
							if (resBulk && resBulk.length > 0) {
								var dataSetAddress = [];

								for (var i = 0; i < resBulk.length; i++) {
									var resTrip = resBulk[i];
									var itemToUpdate = self.tripsSummaryItems.find(item => {
										return (position == "start" && item.first_start_location_trip_id == resTrip.id) || (position == "end" && item.last_end_location_trip_id == resTrip.id);
									});
									if (itemToUpdate) {
										var res = resTrip.data;
										if (res && res.length > 0) {
											var newAddress = self._.find(res, function(item) {
												return (
													self._.find(item.types, function(x) {
														return x === "streetAddress";
													}) != null
												);
											});

											if (!newAddress) {
												newAddress = res[0];
											}

											var address = "";
											if (newAddress && newAddress.formattedAddress) {
												address = newAddress.formattedAddress;

												dataSetAddress.push({
													id: resTrip.id,
													position: position,
													displayName: address
												});
											}
											itemToUpdate.address = address;

											switch (position) {
												case "start":
													itemToUpdate.first_start_location_display_name = address;
													//updateServerAddress(item.id, position, address);
													break;
												case "end":
													itemToUpdate.last_end_location_display_name = address;
													//updateServerAddress(item.id, position, address);
													break;
												case "lastKnown":
													itemToUpdate.last_known_location_display_name = address;
													//updateServerAddress(item.id, position, address);
													break;
											}
										}
									}
								}

								if (dataSetAddress.length > 0) {
									updateServerAddressBulk(dataSetAddress);
								}
							}
						})
						.finally(() => {
							//if (self.loadingAddress.length > 0) self.loadingAddress.pop();
						});
				}
			};

			var indexStart = 1;
			var indexEnd = 1;
			var dataGetAddressStart = [];
			var dataGetAddressEnd = [];

			for (var i = 0; i < items.length; i++) {
				var item = items[i];
				//start location
				if ((self._.isNull(item.first_start_location_display_name) || item.first_start_location_display_name.length == 0) && self._.isNull(item.first_start_location) === false) {
					var params = {
						id: item.first_start_location_trip_id,
						latitude: item.first_start_location.lat,
						longitude: item.first_start_location.lon
					};

					dataGetAddressStart.push(params);

					if (indexStart % 25 == 0) {
						bulkGetAddress(dataGetAddressStart, "start");
						dataGetAddressStart = [];
					}

					indexStart++;
				}

				//end location
				if ((self._.isNull(item.last_end_location_display_name) || item.last_end_location_display_name.length == 0) && self._.isNull(item.last_end_location) === false) {
					var params = {
						id: item.last_end_location_trip_id,
						latitude: item.last_end_location.lat,
						longitude: item.last_end_location.lon
					};

					dataGetAddressEnd.push(params);

					if (indexEnd % 25 == 0) {
						bulkGetAddress(dataGetAddressEnd, "end");
						dataGetAddressEnd = [];
					}

					indexEnd++;
				}
			}

			if (dataGetAddressStart.length > 0) {
				bulkGetAddress(dataGetAddressStart, "start");
			}

			if (dataGetAddressEnd.length > 0) {
				bulkGetAddress(dataGetAddressEnd, "end");
			}
		},

		// setAddressTripLive(tripsItems) {
		// 	var self = this;

		// 	var updateServerAddressBulk = function(data) {
		// 		ApiService.setTripPositionDisplayNameBulk(data);
		// 	};

		// 	var bulkGetAddress = function(data, position) {
		// 		if (data.length > 0) {
		// 			ApiService.getBulkReverseGeocoding(data).then(resBulk => {
		// 				if (resBulk && resBulk.length > 0) {
		// 					var dataSetAddress = [];

		// 					for (var i = 0; i < resBulk.length; i++) {
		// 						var resTrip = resBulk[i];
		// 						var itemToUpdate = self.tripsItems.find(item => {
		// 							return item.id == resTrip.id;
		// 						});
		// 						if (itemToUpdate) {
		// 							var res = resTrip.data;
		// 							if (res && res.length > 0) {
		// 								var newAddress = self._.find(res, function(item) {
		// 									return (
		// 										self._.find(item.types, function(x) {
		// 											return x === "streetAddress";
		// 										}) != null
		// 									);
		// 								});

		// 								if (!newAddress) {
		// 									newAddress = res[0];
		// 								}

		// 								var address = "";
		// 								if (newAddress && newAddress.formattedAddress) {
		// 									address = newAddress.formattedAddress;

		// 									dataSetAddress.push({
		// 										id: itemToUpdate.id,
		// 										position: position,
		// 										displayName: address
		// 									});
		// 								}
		// 								itemToUpdate.address = address;

		// 								switch (position) {
		// 									case "start":
		// 										itemToUpdate.first_start_location_display_name = address;
		// 										//updateServerAddress(item.id, position, address);
		// 										break;
		// 									case "end":
		// 										itemToUpdate.last_end_location_display_name = address;
		// 										//updateServerAddress(item.id, position, address);
		// 										break;
		// 									case "lastKnown":
		// 										itemToUpdate.last_known_location_display_name = address;
		// 										//updateServerAddress(item.id, position, address);
		// 										break;
		// 								}
		// 							}
		// 						}
		// 					}

		// 					if (dataSetAddress.length > 0) {
		// 						updateServerAddressBulk(dataSetAddress);
		// 					}
		// 				}
		// 			});
		// 		}
		// 	};

		// 	var indexStart = 1;
		// 	var indexEnd = 1;
		// 	var indexLastKnown = 1;
		// 	var dataGetAddressStart = [];
		// 	var dataGetAddressEnd = [];
		// 	var dataGetAddressLastKnown = [];

		// 	for (var i = 0; i < tripsItems.length; i++) {
		// 		var item = tripsItems[i];
		// 		//start location
		// 		if ((self._.isNull(item.first_start_location_display_name) || item.first_start_location_display_name.length == 0) && self._.isNull(item.first_start_location) === false) {
		// 			var params = {
		// 				id: item.id,
		// 				latitude: item.first_start_location.lat,
		// 				longitude: item.first_start_location.lon
		// 			};

		// 			dataGetAddressStart.push(params);

		// 			if (indexStart % 25 == 0) {
		// 				bulkGetAddress(dataGetAddressStart, "start");
		// 				dataGetAddressStart = [];
		// 			}

		// 			indexStart++;
		// 			//getAddress(item, "start", params);
		// 		}

		// 		//end location
		// 		if ((self._.isNull(item.last_end_location_display_name) || item.last_end_location_display_name.length == 0) && self._.isNull(item.last_end_location) === false) {
		// 			var params = {
		// 				id: item.id,
		// 				latitude: item.last_end_location.lat,
		// 				longitude: item.last_end_location.lon
		// 			};

		// 			dataGetAddressEnd.push(params);

		// 			if (indexEnd % 25 == 0) {
		// 				bulkGetAddress(dataGetAddressEnd, "end");
		// 				dataGetAddressEnd = [];
		// 			}

		// 			indexEnd++;
		// 			//getAddress(item, "end", params);
		// 		}
		// 	}

		// 	if (dataGetAddressStart.length > 0) {
		// 		bulkGetAddress(dataGetAddressStart, "start");
		// 	}

		// 	if (dataGetAddressEnd.length > 0) {
		// 		bulkGetAddress(dataGetAddressEnd, "end");
		// 	}

		// 	if (dataGetAddressLastKnown.length > 0) {
		// 		bulkGetAddress(dataGetAddressLastKnown, "lastKnown");
		// 	}
		// },

		getCategoriesData() {
			var self = this;
			ApiService.getCategoriesData().then(res => {
				self.categories = res.map(function(item) {
					return {
						id: item.id,
						box_drive_icon: item.box_drive_icon,
						box_stop_icon: item.box_stop_icon,
						box_still_icon: item.box_still_icon
					};
				});
				//self.getData();
			});
		},
		getIconFromCategories(categoryId, status, lastPrivacyMode, box_active) {
			var cat = this.categories.find(function(c) {
				return c.id == categoryId;
			});

			if (!box_active) {
				return "/assets/map/icon/blank.png";
			}

			if (lastPrivacyMode) {
				return "../../assets/map/icon/privacy_mod.png";
			}

			var icon = "";

			if (cat) {
				switch (status) {
					case "off":
						if (cat.box_stop_icon) icon = cat.box_stop_icon;
						break;
					case "stop":
						if (cat.box_still_icon) icon = cat.box_still_icon;
						break;
					case "active":
						if (cat.box_drive_icon) icon = cat.box_drive_icon;
						break;
					default:
						break;
				}
			}

			return icon || "/assets/map/icon/blank.png";
		}
		//#endregion
	},

	computed: {
		...mapGetters(["settings"]),
		getStateMIcon() {
			return `../../${helpers.getStateMIcon(this.showMap)}`;
		},
		getStateHTIcon() {
			return `../../${helpers.getStateHTIcon(this.showTable)}`;
		},
		startDateString() {
			return moment(this.startDate).format("DD MMMM YYYY HH:mm");
		},
		endDateString() {
			return moment(this.endDate).format("DD MMMM YYYY HH:mm");
		},
		mapClass: function() {
			if (this.showTable) {
				return "mapwithHorizontalTable";
			}

			return " mapNoTables";
		},
		isLoadingData: function() {
			return this.loadingGetData || this.loadingRealTimeData || this.loadingAddress.length > 0;
		}
		// updateLoopItemsOnOff() {
		// 	if (this.updateLoopItems.length > 0 && this.updateLoopIntervalObject == null) {
		// 		this.pollData();
		// 	} else if (this.updateLoopItems.length == 0) {
		// 		clearInterval(this.updateLoopIntervalObject);
		// 		this.updateLoopIntervalObject = null;
		// 	}
		// }
	}
};
